import React, { useState, useEffect,  } from 'react'
import API from '../utils/api';
import { Container, Button, Table } from 'react-bootstrap';
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
import Row from 'react-bootstrap/Row';
import Error from '../Error';
import axios from 'axios';
import { PlusLg, Trash } from 'react-bootstrap-icons';
import Pagination from '../utils/Pagination';
import Card from 'react-bootstrap/Card';
import { Label, Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap';
import ExportExcel from '../utils/excelexports';
import InputGroup from 'react-bootstrap/InputGroup';
import FloatingLabel from 'react-bootstrap/FloatingLabel';
import swal from 'sweetalert';
import { formatearFecha } from '../utils/FormatearFecha';

const Gastos = () => {
  var url = API.urlAPI
  const urlGastos = url + "gastos"
  const [search, setSearch] = useState("")

  const [gastos, setGastos] = useState([]);

  const [currentPage, setCurrentPage] = useState(1);
  const [recordsPerPage] = useState(25);
  const indexOfLastRecord = currentPage * recordsPerPage;
  const indexOfFirstRecord = indexOfLastRecord - recordsPerPage;
  const currentRecords = gastos.slice(indexOfFirstRecord, indexOfLastRecord);
  const nPages = Math.ceil(gastos.length / recordsPerPage)

  const [modalEliminar, setModalEliminar] = useState(false);
  const [error, setError] = useState(false)


  const [GastoSeleccionado, setGastoSeleccionado] = useState({

    IdGasto: '',
    Descripcion: '',
    Monto: ''
  })

  const handleChange = e => {
    const { name, value } = e.target;
    setGastoSeleccionado({
      ...GastoSeleccionado,
      [name]: value
    });
    console.log(GastoSeleccionado);
  }
  const abrirCerrarModalEliminar = () => {
    setError(false)
    setModalEliminar(!modalEliminar);
  }
  const getGastos = () => {
    fetch(
      urlGastos
    )
      .then((r) => r.json())
      .then((gastos) => setGastos(gastos))
    console.log(gastos);
  }

  useEffect(() => {
    getGastos();
  }, [])


  const EliminarGasto = async () => {
    await axios.delete(urlGastos + "/" + GastoSeleccionado.IdGasto)
      .then(response => {
        const result = response.data;
        abrirCerrarModalEliminar();
        swal({
          title: "Gasto Eliminado Correactamente!",
          icon: "success",
          showConfirmButton: false,
          timer: 2000
        });
        getGastos();
        console.log(result);
        setGastoSeleccionado({
          IdGasto: '',
          Descripcion: '',
          Monto: ''
        })
      }).catch(error => {
        console.log(error);
      })
  }

  const ContainerStyle = {
    boxShadow: '1px 2px 9px white',
    background: 'white',
    justifyContent: 'center'
  };

  const seleccionarGasto = (item, caso) => {
    setGastoSeleccionado(item);
    (caso === "Editar") ?
      console.log("Eligio otro") : abrirCerrarModalEliminar();
  }
  const handleSubmit = (e) => {
    e.preventDefault();
    const PostGastos = {
      Descripcion: GastoSeleccionado && GastoSeleccionado.Descripcion,
      Monto: GastoSeleccionado && GastoSeleccionado.Monto
    }

    if ([PostGastos.Descripcion, PostGastos.Monto].includes('')) {
      setError(true)
      return;
    }

    setError(false)
    axios.post(urlGastos, PostGastos)
      .then(response => {
        const result = response.data;
        swal({
          title: "Gasto creado correctamente!",
          icon: "success",
          showConfirmButton: false,
          timer: 4000
        });
        setGastoSeleccionado({
          IdGasto: '',
          Descripcion: '',
          Monto: ''
        })
        console.log(result)
        console.log("Detalle Post: ", PostGastos)
        getGastos()



      }
      )
      .catch(err => {
        console.log(err)
        console.log(urlGastos)
        console.log(PostGastos)
        swal({
          title: "Ocurrió un error, contactar con el administrador",
          icon: "error",
          showConfirmButton: false,
          timer: 4000
        });
      })
  };


  const searcher = (e) => {
    setSearch(e.target.value)
  }
  const results = !search ? currentRecords : gastos.filter((dato) => dato.Descripcion.toLocaleLowerCase().includes(search.toLocaleLowerCase()))



  return (
    <div>

      <br></br>
      <Container  >
        <Card style={ContainerStyle} >
          <Card.Header style={{ background: "#005187", color: "white" }}><h3>Administración Gastos</h3></Card.Header>
          <Card.Body  >
            <Form >

              <Row className="mb-3">
                <Form.Group as={Col}>

                  <InputGroup>
                    <FloatingLabel
                      controlId="floatingTextarea1" label="Descripción Gasto"
                    >
                      <Form.Control as="textarea" aria-label="Descripcion" name="Descripcion" value= {GastoSeleccionado.Descripcion} required onChange={handleChange} />
                    </FloatingLabel>
                  </InputGroup>
                </Form.Group>

                <Form.Group as={Col}>
                <InputGroup>
              <InputGroup.Text>$</InputGroup.Text>
              <FloatingLabel
                controlId="floatingTextarea2" label="Monto"
              >
                    <Form.Control type="number" placeholder="Monto" name="Monto" value= {GastoSeleccionado.Monto}  required onChange={handleChange} />
                    </FloatingLabel>
                  </InputGroup>
                </Form.Group>

         
  
              </Row>
                  <br></br>
                  <Button variant='success'
                    style={{
                      border: 'none',
                      borderRadius: '50%',
                      height: '65px',
                      width: '65px'
                    }}
                    type="submit"
                    onClick={(e) => handleSubmit(e)}

                  ><PlusLg size={"lg"}></PlusLg></Button>
             
              {error &&
                <Error><p>Todos los campos son requeridos</p></Error>
              }
            </Form>
          </Card.Body>
        </Card>
     
      <br></br>
      <Card style={ContainerStyle} >
      <Card.Header style={{ background: "#005187", color:"white"}}><h3>Listado Gastos</h3></Card.Header>  
      <Card.Body>
            <br></br>
      <div>
        <input value={search} onChange={searcher} type="text" placeholder='Busqueda por Descripcion' className='form-control' />
        <br></br>
      </div>
      <Table responsive>
      <thead  style={{ background: "#74a7e4", color: "white"}}>
          <tr>
            <th>Id Gasto</th>
            <th>Descripcion</th>
            <th>Monto</th>
            <th>Fecha</th>
            <th>Eliminar</th>
          </tr>
        </thead>
        <tbody>
          {results.map((item) =>
            <tr key={item.IdGasto}>
              <td>{item.IdGasto}</td>
              <td>{item.Descripcion}</td>
              <td>{item.Monto}</td>
              <td>{formatearFecha(item.FechaAlta)}</td>
              <td>
                <Button size='sm' variant='danger' onClick={() => seleccionarGasto(item, "Eliminar")}><Trash /></Button>

              </td>
            </tr>
          )}
        </tbody>
      </Table>
      <Row>
        <Col> <Pagination
          nPages={nPages}
          currentPage={currentPage}
          setCurrentPage={setCurrentPage}
        /></Col>
        <Col><ExportExcel excelData={results} fileName={"Gastos"} /></Col>
      </Row>
</Card.Body>
</Card>
      <Modal isOpen={modalEliminar}>
        <ModalBody>
          ¿Estás seguro que deseas eliminar el Gasto {GastoSeleccionado && GastoSeleccionado.Descripcion} por un monto de {GastoSeleccionado && GastoSeleccionado.Monto}?
        </ModalBody>
        <ModalFooter>
          <button className="btn btn-danger" onClick={() => EliminarGasto()}>
            Sí
          </button>
          <button
            className="btn btn-secondary"
            onClick={() => abrirCerrarModalEliminar()}
          >
            No
          </button>
        </ModalFooter>
      </Modal>
      </Container>
    </div>
  )
}

export default Gastos